export default "__VITE_ASSET__bbyL46SQ__"